module.exports = __webpack_public_path__ + "static/templogo-7828d37b4845d83d9e22bfda72b664eb.png";